export const tangramNextConfig = {
  colors: {
    primary700: '#26102D',
    primary600: '#4C205B',
    primary500: '#73308A',
    primary300: '#A24ABF',
    primary100: '#C186D5',
    primary50: '#E8D2EF',
    primary40: '#F9F4FB',
    secondary700: '#662A00',
    secondary600: '#994000',
    secondary500: '#DB5800',
    secondary300: '#FF8833',
    secondary100: '#FFC499',
    secondary50: '#FFF0E5',
    mineshaft700: '#333333',
    mineshaft600: '#4D4D4D',
    mineshaft500: '#666666',
    mineshaft300: '#999999',
    mineshaft100: '#CCCCCC',
    mineshaft80: '#EAEAEA',
    mineshaft50: '#F2F2F2',
    mineshaft40: '#F6F6F6',
    shiraz700: '#60061D',
    shiraz600: '#91082B',
    shiraz500: '#C10B3A',
    shiraz300: '#F43E6D',
    shiraz100: '#F9A0B6',
    shiraz50: '#FEE7ED',
    greenpea700: '#0D2618',
    greenpea600: '#194D30',
    greenpea500: '#267348',
    greenpea300: '#3FC078',
    greenpea100: '#8CD9AE',
    greenpea50: '#DCF5E7',
    white: '#fff',
  },
};

export const fpThemeTangramNextConfig = {
  colors: {
    primary700: '#0B2E65',
    primary600: '#104393',
    primary500: '#1454B8',
    primary300: '#2070EF',
    primary100: '#A3C2F5',
    primary50: '#E8F0FD',
    primary40: '#F1F6FE',
    secondary700: '#662A00',
    secondary600: '#994000',
    secondary500: '#DB5800',
    secondary300: '#FF8833',
    secondary100: '#FFC499',
    secondary50: '#FFF0E5',
    mineshaft700: '#333333',
    mineshaft600: '#4D4D4D',
    mineshaft500: '#666666',
    mineshaft300: '#999999',
    mineshaft100: '#CCCCCC',
    mineshaft80: '#EAEAEA',
    mineshaft50: '#F2F2F2',
    mineshaft40: '#F6F6F6',
    shiraz700: '#60061D',
    shiraz600: '#91082B',
    shiraz500: '#C10B3A',
    shiraz300: '#F43E6D',
    shiraz100: '#F9A0B6',
    shiraz50: '#FEE7ED',
    greenpea700: '#0D2618',
    greenpea600: '#194D30',
    greenpea500: '#267348',
    greenpea300: '#3FC078',
    greenpea100: '#8CD9AE',
    greenpea50: '#DCF5E7',
    white: '#fff',
  },
};
